import React from "react";
import { BlogPost } from "../types";

interface BlogReadyCardProps {
  blog: BlogPost;
  /** Opens the right-panel blog canvas (editor) for this blog post. */
  onOpenCanvas?: () => void;
}

/**
 * Inline chat card shown on the assistant message after a blog is generated.
 * Mirrors GeneratedPosts ("Posts Ready in Canvas") so the blog flow has the same
 * "Open Canvas" entry point as social posts. Clicking it opens the blog editor
 * panel where the user can edit content, add images, and publish to WordPress.
 */
export const BlogReadyCard: React.FC<BlogReadyCardProps> = ({
  blog,
  onOpenCanvas,
}) => {
  const title = (blog.title || "").trim() || "Untitled blog post";

  return (
    <div className="my-3">
      <button
        type="button"
        onClick={() => onOpenCanvas && onOpenCanvas()}
        disabled={!onOpenCanvas}
        className="group flex w-full items-center justify-between rounded-2xl border border-theme-border bg-gradient-to-r from-theme-surface-ui via-theme-surface to-transparent px-4 py-3 text-left transition-all hover:border-theme-primary/35 hover:from-theme-secondary/20 active:scale-[0.99] disabled:cursor-default disabled:opacity-60"
      >
        <div className="flex min-w-0 items-center gap-3">
          <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-theme-secondary/20 transition-colors group-hover:bg-theme-secondary/30">
            <span className="material-icons text-[20px] text-theme-primary">article</span>
          </span>
          <div className="min-w-0">
            <p className="truncate text-[13px] font-bold text-theme-fg">
              Blog Ready in Canvas
            </p>
            <p className="truncate text-[11px] text-theme-fg-muted">
              {title} — edit &amp; publish on the right →
            </p>
          </div>
        </div>
        <span className="flex flex-shrink-0 items-center gap-1.5 rounded-xl bg-theme-primary px-3 py-1.5 text-[11px] font-bold text-white shadow-sm transition-all group-hover:opacity-90 group-hover:shadow-theme-primary/25 group-hover:shadow-md">
          <span className="material-icons text-[14px]">open_in_new</span>
          Open Canvas
        </span>
      </button>
    </div>
  );
};
